module.exports = __webpack_public_path__ + "static/media/HappySocks-Logo-45px.306a2d21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/HappySocks-Logo-45px.svg
// module id = 457
// module chunks = 0